export default __webpack_public_path__ + "media/img/white-logo-58a31bfcbc668fd0153750e4794b6206.svg";